module.exports = __webpack_public_path__ + "assets/map-589cab.svg";